import React from 'react'
import PropTypes from 'prop-types'
import {
  MdLink,
  MdDescription,
  MdPersonOutline,
  MdInsertInvitation
} from 'react-icons/md'
import { useSelector } from 'react-redux'

import * as enums from '../../../constants/types'
import { formatToBR } from '../../../utils/date'
import routes from '../../../config/routes'
import history from '../../../lib/history'
import DefaultLayout from '../../commons/Layouts/DefaultLayout'
import BoxRounded from '../../commons/BoxRounded/BoxRounded'
import Breadcrumb from '../../commons/Breadcrumb/Breadcrumb'
import Flex from '../../commons/Flex/Flex'
import Text from '../../commons/Text/Text'
import Avatar from '../../commons/Avatar/Avatar'
import Button from '../../commons/Button/Button'
import Active from '../../commons/Icons/Active'
import Stoped from '../../commons/Icons/Stoped'

import styles from './detailProduct.module.scss'

const DetailProduct = (props) => {
  const {
    match: {
      params: { id }
    }
  } = props

  const {
    extract: { product, store }
  } = useSelector((state) => state.extractReducer)

  if (!product?.id) {
    history.push(routes.extract.generate(id))

    return null
  }

  const {
    name,
    company,
    description,
    contractedAt,
    url,
    situation,
    recommendedFor,
    logoImageUrl,
    hasProduct
  } = product

  const breadcrumbs = [
    {
      id: 1,
      title: 'Carteira',
      path: routes.wallet.path
    },
    {
      id: 2,
      title: store?.nameFantasy,
      path: routes.extract.generate(id)
    },
    {
      id: 3,
      title: 'Produto'
    }
  ]

  const _company = enums.ENUM_COMPANY.find((brand) => brand.company === company)

  return (
    <DefaultLayout>
      <div className={styles.page}>
        <div className={styles.header}>
          <Text color="gray" size="lg" variation="dark" bold>
            {name}
          </Text>
          <Breadcrumb items={breadcrumbs} />
        </div>
        <div className={styles.product}>
          <BoxRounded darkGradient flex="1" height="176px">
            <Flex column justifyContent="space-evenly">
              <Avatar title={name} image={logoImageUrl} size="medium" />
              <Text
                margin="24px 0px 8px 0px"
                color="gray"
                variation="lightest"
                bold
                size="md"
              >
                {name}
              </Text>
              <Text font="custom" variation="lightest" size="xs" color="gray">
                {_company.value}
              </Text>
            </Flex>
          </BoxRounded>
        </div>
        <div className={styles.link}>
          <BoxRounded height="176px">
            <Flex column flex="1" justifyContent="space-between">
              <Text
                bold
                color="gray"
                variation="dark"
                size="md"
                lineHeight="24px"
              >
                Contratar
              </Text>
              <Text
                color="gray"
                font="custom"
                size="xs"
                lineHeight="24px"
                fontWeight="400"
              >
                Acesse a página do produto
              </Text>
              <a href={url} target="blank">
                <Button type="secondary" buttonType="button" width="100%">
                  Contratar
                  <MdLink size={15} style={{ marginLeft: 10 }} />
                </Button>
              </a>
            </Flex>
          </BoxRounded>
        </div>
        <div className={styles.description}>
          <Text
            color="gray"
            variation="dark"
            size="lg"
            extraBold
            lineHeight="30px"
            margin="0px 0px 32px 0px"
            bold
          >
            Detalhe do produto
          </Text>
          <BoxRounded margin="20px 0px">
            <Flex column>
              <Flex alignItems="center">
                <div className={styles.boxIcon}>
                  <MdDescription size={18} color="#737373" o />
                </div>
                <Text
                  size="md"
                  color="gray"
                  variation="dark"
                  lineHeight="24px"
                  fontWeight="600"
                >
                  Descrição
                </Text>
              </Flex>
              <Text
                margin="20px 0px"
                color="gray"
                variation="dark"
                fontWeight="400"
                font="custom"
                size="xs"
                lineHeight="20px"
              >
                {description}
              </Text>
            </Flex>
            <div className={styles.divider} />
            <Flex column>
              <Flex alignItems="center">
                <div className={styles.boxIcon}>
                  <MdPersonOutline size={18} color="#737373" />
                </div>
                <Text
                  size="md"
                  color="gray"
                  variation="dark"
                  lineHeight="24px"
                  fontWeight="600"
                >
                  Recomendações
                </Text>
              </Flex>
              <Text
                margin="20px 0px"
                color="gray"
                variation="dark"
                fontWeight="400"
                font="custom"
                size="xs"
                lineHeight="20px"
              >
                {recommendedFor}
              </Text>
            </Flex>
            <div className={styles.divider} />
            <Flex column>
              <Flex alignItems="center">
                <div className={styles.boxIcon}>
                  <MdInsertInvitation size={18} color="#737373" />
                </div>
                <Text
                  size="md"
                  color="gray"
                  variation="dark"
                  lineHeight="24px"
                  fontWeight="600"
                >
                  Contratado em
                </Text>
              </Flex>
              <Text
                margin="20px 0px"
                color="gray"
                variation="dark"
                fontWeight="400"
                font="custom"
                size="xs"
                lineHeight="20px"
              >
                {formatToBR(contractedAt)}
              </Text>
            </Flex>
          </BoxRounded>
        </div>
        <div className={styles.status}>
          <Text
            color="gray"
            variation="dark"
            size="lg"
            extraBold
            lineHeight="30px"
            margin="0px 0px 32px 0px"
          >
            Situação do Produto
          </Text>

          {hasProduct && (
            <div className={styles.boxStatus}>
              <Text
                size="md"
                color="gray"
                variation="dark"
                lineHeight="24px"
                fontWeight="600"
              >
                Contratado
              </Text>

              <Flex alignItems="center">
                <Active />
                <Text
                  color="gray"
                  extraBold
                  variation="dark"
                  size="lg"
                  lineHeight="30px"
                  margin="0px 0px 0px 10px"
                >
                  Ativo
                </Text>
              </Flex>
            </div>
          )}
          <div className={styles.boxStatus}>
            <Text
              size="md"
              color="gray"
              variation="dark"
              lineHeight="24px"
              fontWeight="600"
            >
              Operação
            </Text>

            <Flex alignItems="center">
              <Stoped />
              <Text
                color="gray"
                extraBold
                variation="dark"
                size="lg"
                lineHeight="30px"
                margin="0px 0px 0px 10px"
              >
                {situation}
              </Text>
            </Flex>
          </div>
        </div>
      </div>
    </DefaultLayout>
  )
}

DetailProduct.defaultProps = {
  match: {
    params: {
      id: null
    }
  }
}

DetailProduct.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string
    })
  })
}

export default DetailProduct
